import React, { Fragment } from 'react'
import { Select, Input } from 'antd'

const InputSelect = ({ type, title, options, placeholder, handleChangeBrandInput, valueInput, errors, keyErr, errBrand }) => {
    return (
        <Fragment>
            {
                type === 'select' && (
                    <div className='InputSelect d-flex flex-column'>
                        <label>{title} <span className='text-danger'>*</span></label>
                        <Select
                            style={{ width: '50%' }}
                            placeholder={placeholder}
                            allowClear
                            showSearch
                            value={valueInput || []}
                            onChange={handleChangeBrandInput}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={options || []}
                        />
                        {errors && <span className='text-danger mt-1'>{errors[keyErr]}</span>}
                        {errBrand && title === "Brand" && <span className='text-danger mt-1'>{errBrand}</span>}
                    </div>
                )
            }

            {
                type === 'input' && (
                    <div className='InputSelect d-flex flex-column'>
                        <label>{title} <span className='text-danger'>*</span></label>
                        <Input
                            style={{ width: '50%' }}
                            allowClear
                            value={valueInput}
                            onChange={e => handleChangeBrandInput(e.target.value)}
                            className={title === "Quantity" && !!valueInput && +valueInput <= 100 ? 'border border-danger' : ''}
                        />
                        {errors && <span className='text-danger mt-1'>{errors[keyErr]}</span>}
                    </div>
                )
            }

            {
                type === 'cost' && (
                    <div className='InputSelect d-flex flex-column'>
                        <label htmlFor={title}>{title}</label>
                        <div className="InputCost">
                            <label htmlFor={title} className='mr-1 mb-0'>USD</label>
                            <Input
                                style={{ width: '100%' }}
                                allowClear
                                id={title}
                                value={valueInput}
                                onChange={e => handleChangeBrandInput(e.target.value)}
                            />
                        </div>
                        {errors && <span className='text-danger mt-1'>{errors[keyErr]}</span>}
                    </div>
                )
            }

        </Fragment>
    )
}

export default InputSelect